
import { GoogleLogin,GoogleOAuthProvider } from '@react-oauth/google';
import axios from 'axios';
import querystring from 'querystring';
import { toast } from "react-toastify"
import { useHistory, useLocation } from 'react-router-dom';

const CustomerGoogleLogin = () => {
    const history = useHistory();
    const location = useLocation();
    const nav_path = location.state?.nav_path || null;

    const handleGoogleLoginSuccess = async (credentialResponse) => {
        try {
            const googleToken = credentialResponse.credential;
            console.log("Google Credential Token: ", googleToken);
    
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}google-auth`,
                querystring.stringify({ data: googleToken })
            );
    
      
            if (res.data.success) {
                toast.success('Login successfully.', {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: "colored",
                });
                localStorage.setItem('auth_token',res?.data?.token);
                setTimeout(() => {
                    if(nav_path) history.push(nav_path);
                    else history.push('/customer-dashboard');
                }, 2500)
            }
        } catch (error) {
            console.error("Google Login Error: ", error);
        }
    };


    const handleGoogleLoginFailure = () => {
        console.error('Google Login Failed');
        alert('Google Login Failed');
    };

    return(
        <GoogleOAuthProvider
            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
        >

            <GoogleLogin
              onSuccess={handleGoogleLoginSuccess}
              onError={handleGoogleLoginFailure}
              useOneTap
            />
        </GoogleOAuthProvider>
    );


}



export default CustomerGoogleLogin;